import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { WatchButtonPlaceholder } from '../src/WatchButtonPlaceholder.js';

export const WatchDialog: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialog.js'))
			.WatchDialog,
	loading: WatchButtonPlaceholder,
});
